import api from "./api";
// @ts-expect-error - api is not typed
const { get, post, patch } = api.getPrefixedMethods("escalations");
export const escalationsService = {
    list: (params = {}) => get("", { params }),
    count: () => get("count"),
    getCompanies: () => get("companies"),
    get: (id) => get(`${id}`),
    getRun: (id) => get(`${id}/run`),
    getCase: (id) => get(`${id}/case`),
    suggest: (id) => post(`${id}/suggest`, {}),
    resolve: (id, payload) => post(`${id}/resolve`, payload),
    ignore: (id, note = "") => post(`${id}/ignore`, { note }),
    assign: (id, userId) => post(`${id}/assign`, { userId }),
    getScreenshotUrl: (id, step) => get(`${id}/screenshot-url`, { params: step ? { step } : {} }),
    listGuidance: async (host, businessStatus) => {
        const notes = [];
        let page = 1;
        for (;;) {
            const data = await get("guidance", { params: { host, active: "true", page } });
            notes.push(...data.results.filter((n) => !n.businessStatus || n.businessStatus === businessStatus));
            if (!data.next)
                return notes;
            page += 1;
        }
    },
    updateGuidance: (id, changes) => patch(`guidance/${id}`, changes),
};
